import { HttpEvent } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { IDocument } from 'app/services/api5-service/api.interface';
import { OperatorFunction, pipe } from 'rxjs';

import { HttpResponseHandler } from './model';

/**
 * Http handler service for getting mocks instead of real server answers
 */
@Injectable({
  providedIn: 'root',
})
export class MockHandlerService implements HttpResponseHandler<IDocument> {
  handle<R extends IDocument>(): OperatorFunction<R, R> {
    return pipe();
    // uncomment this line in order to use mocks
    // return pipe(map(doc => (MOCKS as any)[doc.$func] || doc));
  }

  handleEvent<
    R extends IDocument = IDocument,
    E extends HttpEvent<R> = HttpEvent<R>,
  >(): OperatorFunction<E, E> {
    return pipe();
  }
}
